<template>
  <v-container
      v-if="faults && faults.length > 0"
      fluid class="Faults pa-0"
    >
      <v-layout row class="ListHeader my-3 px-4">
        <v-flex xs2 class="subheading mx-1">{{$t("FaultsDetailsList.date")}}</v-flex>
        <v-flex xs2 class="subheading mx-1">{{$t("FaultsDetailsList.code")}}</v-flex>
        <v-flex xs2 class="subheading mx-1">{{$t("FaultsDetailsList.duration")}}</v-flex>
        <v-flex xs4 class="subheading mx-1">{{$t("FaultsDetailsList.timeToGetBack")}}</v-flex>
        <v-flex xs7 class="subheading mx-1">{{$t("FaultsDetailsList.detail")}}</v-flex>
      </v-layout>
      <v-layout
        v-for="item in faultsItems"
        :key="title + locationName + '_fault' + item.id"
        row
        class="ListItem px-4 py-2"
        :class="{Active: (selectedFault && selectedFault.id === item.id)}"
        @click="selectFault(item)"
      >
        <v-flex xs2 class="subheading ma-1">{{item.date}}</v-flex>
        <v-flex xs2 class="subheading ma-1">{{item.code}}</v-flex>
        <v-flex xs2 class="subheading ma-1">{{item.duration}}</v-flex>
        <v-flex xs4 class="subheading ma-1">{{item.recover_time}}</v-flex>
        <v-flex xs7 class="subheading ma-1">{{item.details}}</v-flex>
      </v-layout>
    </v-container>
</template>

<script>
import { setZonedTimeFromIso } from '../../../lib/time-transformations'

export default {
  data () {
    return {
      selectedFault: null
    }
  },
  props: ['faults', 'title', 'locationName'],
  computed: {
    faultsItems () {
      return this.faults.map(fault => {
        const result = {
          id: fault.id,
          code: fault.code,
          duration: fault.duration,
          recover_time: fault.recover_time,
          details: fault.details,
          from_angle: parseInt(fault.from_angle).toString(),
          to_angle: parseInt(fault.to_angle).toString(),
          raw_start: fault.start
        }
        const date = fault.start ? new Date(fault.start).toLocaleDateString('es-ES', {month: 'numeric', day: 'numeric'}) : '-'
        result.date = date

        let start = fault.start ? setZonedTimeFromIso(fault.start) : '-'
        if (start.split(':')[1] && start.split(':')[0].includes('12') && start.includes('AM')) {
          start = `00${start.substr(2)}`
        }
        result.start = start
        let end = fault.end ? setZonedTimeFromIso(fault.end) : '-'
        if (end.split(':')[1] && end.split(':')[0].includes('12') && end.includes('AM')) {
          end = `00${end.substr(2)}`
        }
        result.end = end

        result.type = fault.is_pump_type ? this.$t('FaultsDetailsList.pump') : this.$t('FaultsDetailsList.equipment')

        return result
      }).sort((a, b) => {
        if (a.raw_start < b.raw_start) {
          return -1
        }
        return 0
      })
    }
  },
  methods: {
    selectFault (fault) {
      if (this.selectedFault && this.selectedFault.id === fault.id) {
        this.selectedFault = null
        this.$emit('update:selectedFault', null)
      } else {
        this.selectedFault = fault
        this.$emit('update:selectedFault', fault)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// FaultsDetailsList.vue?541e0c30